<template>
  <authorization permissionKey="exams_queue" can="read">
    <Attendances
      queueType="exam_identification"
      :attendancePlaceId="attendancePlaceId"
    >
      <template v-slot:attendance="{ attendance }">
        <MedicalRequestQueue
          :attendance="attendance"
          queueType="exam_identification"
        />
      </template>
    </Attendances>
  </authorization>
</template>

<script>
import Attendances from "@/components/queues/attendances.vue";
import MedicalRequestQueue from "@/components/medical_request/queue.vue";

export default {
  name: "IdentificationExams",
  components: {
    Attendances,
    MedicalRequestQueue,
  },
  props: {
    attendancePlaceId: String,
  },
};
</script>

<style lang="scss" scoped></style>
